import script from "./Step2.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2.vue?vue&type=script&setup=true&lang=js"

import "./Step2.vue?vue&type=style&index=0&id=3be3ae18&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be3ae18"]])

export default __exports__